// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PZ8b3","rootMobile":"styles_rootMobile__1I6_G"};